<div class="tables-responsive">
    <div class="row">
        <div class="col-md-4">
            <!-- ===== TOTAL ===== -->
            <div class="table-block">
                <div class="table-header">TOTAL</div>

                <div class="table-content">
                    <dx-data-grid class="dashboard-grid" [dataSource]="totalData" [showBorders]="true" [columnAutoWidth]="true" [wordWrapEnabled]="true">
                        <dxo-sorting mode="none"></dxo-sorting>
                        <dxo-scrolling mode="standard" [useNative]="true"></dxo-scrolling>

                        <!-- columns -->
                        <dxi-column dataField="block" caption="BLOCK"></dxi-column>
                        <!-- <dxi-column dataField="unit" caption="Unit"></dxi-column> -->
                        <dxi-column dataField="equipment" caption="Equipment"></dxi-column>
                        <dxi-column dataField="recEquip" caption="Received Equipments"></dxi-column>
                        <dxi-column dataField="recJoint" caption="Received Joints"></dxi-column>
                        <dxi-column dataField="uploaded" caption="iDMS Uploaded"></dxi-column>
                        <dxi-column dataField="printed" caption="Tags Printed"></dxi-column>
                        <dxi-column dataField="tagged" caption="Joints Tagged"></dxi-column>
                        <dxo-summary>
                            <dxi-total-item column="block" displayFormat="TOTAL"></dxi-total-item>
                            <dxi-total-item column="equipment" summaryType="sum"></dxi-total-item>
                            <dxi-total-item column="recEquip" summaryType="sum"></dxi-total-item>
                            <dxi-total-item column="recJoint" summaryType="sum"></dxi-total-item>
                            <dxi-total-item column="uploaded" summaryType="sum"></dxi-total-item>
                            <dxi-total-item column="printed" summaryType="sum"></dxi-total-item>
                            <dxi-total-item column="tagged" summaryType="sum"></dxi-total-item>
                            <dxi-total-item summaryType="sum" showInColumn="equipment" column="equipment" [customizeText]="percentText"> </dxi-total-item>
                        </dxo-summary>
                        <!-- Prevent column stretching -->
                        <dxo-column-fixing [enabled]="false"></dxo-column-fixing>

                        <!-- Optional: avoid resize jumps -->
                        <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                    </dx-data-grid>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <!-- ===== EIS ===== -->
            <div class="table-block">
                <div class="table-header">EIS</div>
                <div class="table-content">
                    <dx-data-grid class="dashboard-grid" [dataSource]="eisData" [showBorders]="true" [columnAutoWidth]="true" [wordWrapEnabled]="true">
                        <dxo-sorting mode="none"></dxo-sorting>
                        <dxo-scrolling mode="standard" [useNative]="true"></dxo-scrolling>

                        <dxi-column dataField="equipment" caption="Equipment"></dxi-column>
                        <dxi-column dataField="recEquip" caption="Received Equipments"></dxi-column>
                        <dxi-column dataField="recJoint" caption="Received Joints"></dxi-column>
                        <dxi-column dataField="uploaded" caption="iDMS Uploaded"></dxi-column>
                        <dxi-column dataField="printed" caption="Tags Printed"></dxi-column>
                        <dxi-column dataField="tagged" caption="Joints Tagged"></dxi-column>

                        <dxo-summary>
                            <dxi-total-item column="equipment" summaryType="sum"></dxi-total-item>
                            <dxi-total-item column="recEquip" summaryType="sum"></dxi-total-item>
                            <dxi-total-item column="recJoint" summaryType="sum"></dxi-total-item>
                            <dxi-total-item column="uploaded" summaryType="sum"></dxi-total-item>
                            <dxi-total-item column="printed" summaryType="sum"></dxi-total-item>
                            <dxi-total-item column="tagged" summaryType="sum"></dxi-total-item>

                            <dxi-total-item summaryType="sum" showInColumn="equipment" column="equipment" [customizeText]="percentText"> </dxi-total-item>
                        </dxo-summary>
                        <!-- Prevent column stretching -->
                        <dxo-column-fixing [enabled]="false"></dxo-column-fixing>

                        <!-- Optional: avoid resize jumps -->
                        <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                    </dx-data-grid>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <!-- ===== NEIS ===== -->
            <div class="table-block">
                <div class="table-header">NEIS</div>
                <div class="table-content">
                    <dx-data-grid class="dashboard-grid" [dataSource]="neisData" [showBorders]="true" [columnAutoWidth]="true" [wordWrapEnabled]="true">
                        <dxo-sorting mode="none"></dxo-sorting>
                        <dxo-scrolling mode="standard" [useNative]="true"></dxo-scrolling>

                        <dxi-column dataField="equipment" caption="Equipment"></dxi-column>
                        <dxi-column dataField="recEquip" caption="Received Equipments"></dxi-column>
                        <dxi-column dataField="recJoint" caption="Received Joints"></dxi-column>
                        <dxi-column dataField="uploaded" caption="iDMS Uploaded"></dxi-column>
                        <dxi-column dataField="printed" caption="Tags Printed"></dxi-column>
                        <dxi-column dataField="tagged" caption="Joints Tagged"></dxi-column>
                        <dxo-summary>
                            <dxi-total-item column="equipment" summaryType="sum"></dxi-total-item>
                            <dxi-total-item column="recEquip" summaryType="sum"></dxi-total-item>
                            <dxi-total-item column="recJoint" summaryType="sum"></dxi-total-item>
                            <dxi-total-item column="uploaded" summaryType="sum"></dxi-total-item>
                            <dxi-total-item column="printed" summaryType="sum"></dxi-total-item>
                            <dxi-total-item column="tagged" summaryType="sum"></dxi-total-item>
                            <dxi-total-item summaryType="sum" showInColumn="equipment" column="equipment" [customizeText]="percentText"> </dxi-total-item>
                        </dxo-summary>
                        <!-- Prevent column stretching -->
                        <dxo-column-fixing [enabled]="false"></dxo-column-fixing>

                        <!-- Optional: avoid resize jumps -->
                        <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                    </dx-data-grid>
                </div>
            </div>
        </div>
    </div>
</div>
